/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

require('expose-loader?_scope.Utils!./helper/utils.js');

require('expose-loader?JSON!json3');

require('expose-loader?_scope.Entry!./components');

var _nats = require('./libs/nats');

// iframe标记
window.IS_IFRAME = window.self !== window.top;

switch (window.MUDU_SERVER_ENV) {
    case 'UAT':
        // uat环境要重设ws域名
        window.NAT_SERVERS = ['wss://mdl-ws-msg.uat.mudu.tv'];
        window.IM_SERVER = 'wss://mdl-live-msg.uat.mudu.tv/sub';
        break;
    case 'TEST':
        window.NAT_SERVERS = ['wss://mdl-ws-msg.test.mudu.tv'];
        // window.IM_SERVER = 'wss://mdl-live-msg.test.mudu.tv/sub'; // 腾讯test，websdk暂时不加这个环境
        window.IM_SERVER = 'wss://testsvc-3.mudu.tv/sub';
        break;
    case 'TX_PROD':
    case 'PROD':
    default:
        // tx环境要重设ws域名
        window.NAT_SERVERS = ['wss://msg-ws.mudu.tv'];
        window.IM_SERVER = 'wss://live-msg.mudu.tv/sub';
}

require('expose-loader?rop!messager');
(0, _nats.createNatsClient)();

if (typeof window.Mudu === 'undefined') {
    window.Mudu = _scope.Entry;
}



/*****************
 ** WEBPACK FOOTER
 ** ./application/index.js
 ** module id = 12
 ** module chunks = 1
 **/